import { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { usePathFactory } from "@sia/style-guide";
import { MasterKeyContext } from "contexts/MasterKeyContext";
import masterKeyValidationAdapter from "common/Adapters/MasterKeyValidationAdapter/Router";
import useSurveyMasterKeyWorkflow from "./useSurveyMasterKeyWorkflow";
import GlobalContext from "contexts/GlobalContext";

const useMasterKeyModal = (translate) => {
  const history = useHistory();
  const pathFactory = usePathFactory();
  const { user } = useContext(GlobalContext);
  const { isLoggingOut, isMasterKeyModalShown, setIsMasterKeyModalShown } = useContext(MasterKeyContext);

  const close = () => setIsMasterKeyModalShown(false);

  const workflow = useSurveyMasterKeyWorkflow({
    translate,
    initialMode: "enter-key",
    onAuthenticated: () => {
      close();
      history.push(pathFactory.create("survey"));
    },
    onClose: close,
  });

  useEffect(() => {
    if (isLoggingOut) {
      if (isMasterKeyModalShown) setIsMasterKeyModalShown(false);
      return undefined;
    }

    if (!user || !isMasterKeyModalShown) return undefined;

    let mounted = true;
    workflow.resetInputs("enter-key");

    masterKeyValidationAdapter
      .exists()
      .then((response) => {
        if (mounted) {
          workflow.changeMode(response?.data?.valid ? "enter-key" : "create-key");
        }
      })
      .catch((error) => {
        console.error("Failed to check whether master key exists", error);

        if (!mounted) return;
        workflow.changeMode("create-key");
      });

    return () => {
      mounted = false;
    };
  }, [isLoggingOut, isMasterKeyModalShown, setIsMasterKeyModalShown, user]);

  return {
    isMasterKeyModalShown: isMasterKeyModalShown && !isLoggingOut,
    ...workflow,
  };
};

export default useMasterKeyModal;
